<ng-select-company
  *ngIf="(store$ | async) as store"
  [customers]="store.customers"
  [contractToUpdate]="store.core.loa"
  [isEdit]="store.stepper.isEdit"
  (selected)="selectedCustomer($event)"
  (nextEmitter)="nextStep()">
</ng-select-company>
